import styled from 'styled-components';

import { brandFont } from 'styles/brand-font';

export const DeliveryAvailableMessage = styled.p`
  font: ${brandFont.copyOne};
  text-align: center;
  margin-block-end: 0;
`;

export const DeliveryAvailableTime = styled.span`
  font: ${brandFont.headerOne};
  display: block;
  line-height: 1.75rem;
`;
